<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="6">
         <!-- FIELD INPUTS -->

          <!--Get Away Times -->
          <drop-down-field
              field-name="When can you get away?"
              field-key="get_away_times"
              select-word="Time"
              :selected-value="null"
              :options-json="optionsExerciseFieldsJSON"
              @selected-option="handleFieldItemSelected"
          />


          <!--Go Places -->
          <drop-down-field
              field-name="Where will you go?"
              field-key="go_places"
              select-word="Place"
              :selected-value="null"
              :options-json="optionsExerciseFieldsJSON"
              @selected-option="handleFieldItemSelected"
          />

          <!-- To Do-->
          <drop-down-field
              field-name="What will you do?"
              field-key="to_do"
              select-word="Activity"
              :selected-value="null"
              :options-json="optionsExerciseFieldsJSON"
              @selected-option="handleFieldItemSelected"
          />
        </b-col>
        <b-col cols="6">
          <!--Music -->
          <b-form-group
              description="Choose the songs you would like to play while exercising"
          >
            <label-info
                id="exercise-playlist"
                label-name="Exercise PlayList:"
                label-info="Songs are provided by PlayList"
            />
            <b-row>
              <b-col cols="1">
                <b-img
                    v-bind="iconImgProps"
                    rounded alt="Rounded image"
                />
              </b-col>
              <b-col cols="1">
                <item-store
                    :modal-id="modalSongStoreId"
                    store-title="Provided by PlayList"
                    btn-download-title="Add A Background song"
                    name="title"
                    asset-url-path="/assets/apps/playlist/"
                    :store-items="_pubStoreAudioItemsPlayList"
                    :user-owned-items="[]"
                    @selected-items="handleSelectedAudios"
                />
              </b-col>
              <b-col cols="10">
                <b-img
                    v-bind="mainPropAlbumCover"
                    v-for="(aSong, s) in settingsUser.bgSongs"
                    :src="`${assetsPathFromPlayList}${aSong.imgURL}`"
                    rounded
                    :alt="`${aSong.title} image`"
                    :key="`song_${s}`"
                    style="margin-right: 5px"
                >TEST
                </b-img>
              </b-col>
            </b-row>
          </b-form-group>
          <hr />
          <b-form-group
              label="Premium"
              description="These fields can be modfified after the plan has been created."
          >
            <toggles-form
                :data-array="toggles"
                @toggles-change="handleToggleChange"
            />
          </b-form-group>
          <!-- Connects --->
          <b-button variant="primary btn-round-fill"
                    @click="handleGenerateABend">
            Generate Bend Plan
          </b-button>

          <bend-plan-row
              v-for="(aBend, j) in userDataBends"
              :bend="aBend"
              :resource="resource"
              :key="`bpr-${j}`"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropDownField from "@/components/common/dropDownField";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
import ItemStore from "@/components/blockResources/_components/itemStore";
import optionsExerciseFieldsJSON from "../../assets/json/optionsSolitudeQuestions.json";

import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import ExerciseField from "./exerciseField";
import storeItemsAudioJSON from "../../assets/json/storeItemsSongs.json";
import _pubStoreAudioItemsPlayListJSON from "@/assets/_appPublic/playList/assets/json/storeItemsSongs.json"
import BendPlanRow from '../../_components/bendPlanRow';

export default {
  name: "Settings_Solitude",
  components: {
    DropDownField,
    ExerciseField,
    ItemStore,
    LabelInfo,
    BendPlanRow
  },
  mixins: [ResourceBlockSettings],
  created() {
    //this.resetformSolitude();
  },
  computed: {
    ...mapGetters({
      profile: "user/profile",
      userData: "user/appsData"
    }),
    iconImgProps() {
      if (this.iconURLFromPlayList) {
        this.mainProps.src = this.iconURLFromPlayList;
      }
      return this.mainProps;
    },
    _pubStoreAudioItemsPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.public &&
      Array.isArray(_pubStoreAudioItemsPlayListJSON.public) &&
      _pubStoreAudioItemsPlayListJSON.public[0].data &&
      Array.isArray(_pubStoreAudioItemsPlayListJSON.public[0].data) ?
          _pubStoreAudioItemsPlayListJSON.public[0].data :[];
    },
    assetsPathFromPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.pathAssets?
          _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.pathAssets:"";
    },
    iconURLFromPlayList() {
      return  _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.urlIconImg?
          _pubStoreAudioItemsPlayListJSON && _pubStoreAudioItemsPlayListJSON.urlIconImg:"";
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile ? `${this.profile.firstname} ${this.profile.lastname}` : null,
        imgURL:  this.profile ? this.profile.imgURL : null
      };
    },
    /* USER DATA */
    userDataBends() {
      return this.userData &&
      this.userData &&
      this.userData[`app_${this.resource.toolId}`] &&
      this.userData[`app_${this.resource.toolId}`].bends
          ? this.userData[`app_${this.resource.toolId}`].bends
          : [];
    }
  },
  methods: {
    handleSelectedAudios(selectedAudios) {
      this.settingsUser.bgSongs = selectedAudios;
    },
    resetFormBend() {
      // this.formSolitude = _.clone(this.formSolitudeDefault);
      //Pull in Health Profile if it exists
    },
    handleFieldItemSelected({key, option}) {
      debugger
      switch (key) {
        case 'exercise_level':
          this.formSolitude.user_info[key] = option.value;
          break;
        default:
          this.formSolitude.preferences[key] = option.value;
          break;
      }
      this.settingsUser.bends = [];
      this.settingsUser.bends.push(this.formSolitude);
    },
    handleExerciseGoalAdded(goalTxt) {
      this.formSolitude.user_info.exercise_goal = goalTxt;
      this.settingsUser.bends = [];
      this.settingsUser.bends.push(this.formSolitude);
    },
    handleGenerateABend(){
      debugger;
      const sysContent = "Task is a weekly work out plan based on the user JSON:\n" +
          "Number of weeks: 2 \n" +
          "\n" +
          "Desired format:\n" +
          "Goal of Exercises: <provide-summarized-text-of-goal>\n" +
          "Day: <day_name>- Repeat for each day of the workout based on exercise_frequency\n" +
          "Exercise: <exercise_name>\n" +
          "Sets:<number_of_sets>\n" +
          "Monitor:<\n" +
          "Repetitions: <number_of_repetitions_per body part>\n" +
          "Notes: <any_notes>\n" +
          "Monitor: <what_to_monitor_and_track_by_eye_or_with_ai>\n" +
          "\n" +
          "Provide in JSON"

      const userContent= JSON.stringify(this.formSolitudeSample);

      debugger;
      this.$store.dispatch("tools/getOpenAIResponse", {
        sysContent: sysContent,
        userContent:userContent
      }).then((resp) => {
        console.log(resp);
        const data = resp.data;
        const bendPlan = {
          _created_at: new Date(),
          _created_by: this.profileBy,
          id: data.id ? data.id : null,
          model: data.model ?data.model : null,
          plan: data.choices && Array.isArray(data.choices)  ? data.choices[0] : null
        }
        this.handleSaveBend(bendPlan);
      }).catch((err)=>{
        console.error(err);
      });
    },
    handleSaveBend(form) {
      debugger;
      let bends = {
        bends: [form]
      };

      let notif = {
        //create message
        title: `Your Bend has been created`,
        description: "Congrats you have your first Bend",
        variant: "success"
      };

      const payload = {
        userData: bends,
        notif: notif,
        key: "bends"
      };

      this.handleUpdateUserData(payload);
    },

  },
  data() {
    return {
      optionsExerciseFieldsJSON,
      bendPlan:null,
      configuration: null,
      openai: null,
      _pubStoreAudioItemsPlayListJSON,
      formSolitude:{},
      formSolitudeDefault: {
        user_info: {
          name: null,
          age: null,
          gender: null,
          height: null,
          weight: null,
          medical_history: [],
          exercise_level: null,
          exercise_goal: null,
          location: null
        },
        preferences: {
          exercise_intensity: null,
          exercise_frequency: null,
          preferred_time: null,
          equipment_available: [],
          exercise_environment: null
        }
      },
      formSolitudeSample:{
        user_info: {
          name:"John Doe",  //Fill in
          age: "70",
          gender: "Male",
          height: "5'11",
          weight: "200lbs",
          medical_history: "Arthritis, High Blood Pressure",
          exercise_level: "Beginner/Intermediate",
          exercise_goal: null,
          location: "City, State"
        },
        preferences: {
          exercise_intensity: "Low Impact",
          exercise_frequency: "3-4 times a week",
          preferred_time: "Morning",
          equipment_available: ["Chair", "Resistance Bands"],
          exercise_environment: "Home"
        }
      },
      settingsUser: {
        bends: this.settings && this.settings.user && this.settings.user.bends
            ? this.settings.user.bends
            : [],
        bgSongs: this.settings && this.settings.user && this.settings.user.bgSongs
            ? this.settings.user.bgSongs
            : [],
        _hasVideos:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasVideos !== undefined
                ? this.settings.user._hasVideos
                : true,
        _hasPostureCorrection:
            this.settings &&
            this.settings.user &&
            this.settings.user._hasPostureCorrection !== undefined
                ? this.settings.user._hasPostureCorrection
                : true,
      },
      /* PLAYLIST STORE */
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 30,
        height: 30,
        class: "m1"
      },
      mainPropAlbumCover: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      modalSongStoreId:"playlist-store-id",
      storeItemsAudioJSON,
      toggles: [
        {
          name: "videos",
          description: "For medications with a limited duration.",
          property: "_hasVideos",
          type: "btns",
          text: "Video Demonstrations",
          isAvail: true,
          value: true
        },
        {
          name: "posture_correction",
          description: "The specific",
          property: "_hasPostureCorrection",
          type: "btns",
          text: "Posture Correction",
          isAvail: true,
          value: true
        }
      ],
    };
  }
};
</script>

<style lang="scss" scoped></style>
